import SubmittedCheckinsReport from './SubmittedCheckinsReport.container';

export default SubmittedCheckinsReport;
